import React from "react";
import { Switch, Route } from "react-router-dom";
import Error404 from "../../../Error404";

import KnowledgeSourceList from "./KnowledgeSourceList";
import KnowledgeSourceForm from "./KnowledgeSourceForm";

export default ({ match }) => {
  return (
    <Switch>
      <Route path={`${match.path}`} exact component={KnowledgeSourceList} />
      <Route path={`${match.path}/:id`} exact component={KnowledgeSourceForm} />
      <Route component={Error404} />
    </Switch>
  );
};
